export default __webpack_public_path__ + "static/media/aboutmain.cd1feb8a.webp";